module.exports = "<div>\n\n  <h6>{{ chartTitle }}</h6>\n\n  <chart style=\"height: 40vh;\" [type]=\"type\" [data]=\"data\" [options]=\"options\"></chart>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/dashboard/dash-graphs/annual-liter-sales/annual-liter-sales.component.html
// module id = ../../../../../src/app/views/dashboard/dash-graphs/annual-liter-sales/annual-liter-sales.component.html
// module chunks = main